import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter  } from 'react-router-dom'
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import store from './store';
import history from './history'
import Layouts from './layouts'
import { THEME_CONFIG } from './configs/AppConfig';
import { usePageViewTracking } from './utils/tracking/usePageViewTracking';
import { useContentsquareGate } from './utils/tracking/useContentsquareGate';
import { useCanonicalUrl } from './utils/hooks/useCanonicalUrl';
import './lang'

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

function TrackingMount() {
  usePageViewTracking();
  useContentsquareGate();
  useCanonicalUrl();
  return null;
}

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <BrowserRouter history={history}>
          <TrackingMount />
          <ThemeSwitcherProvider
            themeMap={themes}
            defaultTheme={THEME_CONFIG.currentTheme}
            insertionPoint="styles-insertion-point"
          >
            <Layouts />
          </ThemeSwitcherProvider>
        </BrowserRouter>
      </Provider>

    </div>
  );
}

export default App;
